import React from 'react'

import SearchInput from '../../../ui/SearchInput'

import Table from '../../../components/Table'
import topArtistsModel from '../../../tables/topArtistsModel'
import { Header, Box } from '../../../ui/layout'

const TopArtists = (props) => (
  <div>
    <Header>
      <Box paddingX={2} flexGrow={1}>
        <SearchInput />
      </Box>
    </Header>
    <Table model={topArtistsModel} />
  </div>
)

export default TopArtists
